import Link from 'next/link';

import cx from 'classnames';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './CanvasCTAViewMore.module.css';

type TProps = {
  onClick?: () => void;
  title?: string;
  to: string;
};

export const CanvasCtaViewMore = ({
  onClick,
  to,
  title = 'View more',
}: TProps) => {
  const { themeMode } = useGGTheme();
  const isDarkMode = themeMode === 'dark';

  return (
    <div className={s.wrapper}>
      <span
        className={cx(s.content, {
          [s.darkMode]: isDarkMode,
          [s.lightMode]: !isDarkMode,
        })}
      >
        <Link href={to} onClick={onClick} className={s.viewMore}>
          {title}
        </Link>
      </span>
    </div>
  );
};
